<template>
  <div>
    <div class="patient_all_list">
      <div class="table-container">
        <div class="table-header item-parent" >
          <div class="item item-value">
            <span>
              {{ $t('user.name') }}
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{ $t('user.email') }}
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{ $t('rehabilitation.time') }}
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{ $t('patient.info.gender.key') }}
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{ $t('patient.info.date_of_birth') }}
              ({{$t('patient.info.age')}})
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{ $t('status.edit') }} /
              {{ $t('status.delete') }}
            </span>
          </div>
          <div
              class="item item-value"
              style="-webkit-box-flex: 2;-ms-flex: 2 2 2rem;flex: 2 2 2rem;"
          >
            <span>
              connection
            </span>
          </div>
        </div>
        <div
            class="table-body item-parent"
            v-for="item in data"
            :key="item.schedule.seqSchedule"
            @click="clickUser(item.patient.seqPatient)"
        >
          <div class="item item-value">
            <span
                v-tooltip="item.patient.patientInfo.patientInfoName"
            >
              {{ item.patient.patientInfo.patientInfoName }}
            </span>
          </div>
          <div class="item item-value">
            <span
                v-tooltip="item.patient.patientEmail"
            >
              {{ item.patient.patientEmail }}
            </span>
          </div>
          <div class="item item-value">
            <span>
              {{`${moment(item.schedule.scheduleExpectStartDatetime).format('hh:mm a')} (${moment.duration(item.schedule.scheduleExpectProgressTime).asMinutes()}${$t('unit.min')})`}}
            </span>
            <img class="online_visit_on"
                 v-show="scheduleStatus(item.schedule.scheduleExpectStartDatetime)"
                 src="/images/ic/etc/ic-videocam-on.svg"
                 alt=""
                 v-on:click.stop.prevent
                 v-on:click="startRmc(item.schedule, item.patient.check)"
                 v-tooltip="item.patient.isAccountSync === false ? $t('alert.not_member_app') : ''"
            />
            <img
                class="online_visit_off"
                v-show="!scheduleStatus(item.schedule.scheduleExpectStartDatetime)"
                src="/images/ic/etc/ic-videocam-off.svg"
                alt=""
                v-on:click.stop.prevent
            />
          </div>
          <div class="item item-value">
            <span>
              {{ computedGender(item.patient.patientInfo.patientInfoGender) }}
            </span>
          </div>
          <div class="item item-value">
            <span
                v-tooltip="item.patient.patientInfo.patientInfoBirth ? `${moment(item.patient.patientInfo.patientInfoBirth).locale($t('country')).format('ll')} (${moment().diff(item.patient.patientInfo.patientInfoBirth, 'years')})` : '-'"
            >
              {{
                item.patient.patientInfo.patientInfoBirth ? `${moment(item.patient.patientInfo.patientInfoBirth).locale($t('country')).format('ll')} (${moment().diff(item.patient.patientInfo.patientInfoBirth, 'years')})` : '-'
              }}
            </span>
          </div>
          <div
              v-if="!item.schedule.isAppointed && item.schedule.seqMedicalRelation !== 0"
              class="item item-value"
              v-tooltip="$t('RMC.patient_appointment')"
              v-on:click.stop.prevent
          >
            <span>
              <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.98 15.1075L7.87 18.9992H4C3.45 18.9992 3 19.4492 3 19.9992C3 20.5492 3.45 20.9992 4 20.9992H20C20.55 20.9992 21 20.5492 21 19.9992C21 19.4492 20.55 18.9992 20 18.9992H11.32L13.92 16.3981L20.7 9.61526C21.09 9.22509 21.09 8.59483 20.7 8.20467L15.79 3.29262C15.4 2.90246 14.77 2.90246 14.38 3.29262L7.60202 10.0734C7.60135 10.0741 7.60067 10.0748 7.6 10.0754C7.59932 10.0761 7.59865 10.0768 7.59797 10.0775L3.98 13.697C3.59 14.0871 3.59 14.7174 3.98 15.1075ZM8.31 12.1963L6.11 14.3972L9.6 17.8887L11.8 15.6878L8.31 12.1963ZM13.21 14.2772L18.58 8.90496L15.09 5.41351L9.72 10.7857L13.21 14.2772Z"
                    fill="#e1dfdd"
                />
              </svg>
            </span>
            &nbsp;&nbsp;
            <span>
              <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13 3.99H19C19.55 3.99 20 4.44 20 4.99C20 5.54 19.55 5.99 19 5.99V20C19 20.55 18.55 21 18 21H6C5.45 21 5 20.55 5 20V5.99C4.45 5.99 4 5.54 4 4.99C4 4.44 4.45 3.99 5 3.99H11V3C11 2.45 11.45 2 12 2C12.55 2 13 2.45 13 3V3.99ZM7 5.99V19H17V5.99H7ZM9.91998 15.5C10.47 15.5 10.92 15.05 10.92 14.5V10.49C10.92 9.93999 10.47 9.48999 9.91998 9.48999C9.36998 9.48999 8.91998 9.93999 8.91998 10.49V14.5C8.91998 15.06 9.35998 15.5 9.91998 15.5ZM14.09 15.5C14.64 15.5 15.09 15.05 15.09 14.5V10.49C15.09 9.93999 14.64 9.48999 14.09 9.48999C13.54 9.48999 13.09 9.93999 13.09 10.49V14.5C13.09 15.06 13.54 15.5 14.09 15.5Z"
                    fill="#e1dfdd"
                />
              </svg>
            </span>
          </div>
          <div
              v-else
              class="item item-value"
              v-on:click.stop.prevent
          >
            <span
                @click="onEventClick($event,item)"
            >
              <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.98 15.1075L7.87 18.9992H4C3.45 18.9992 3 19.4492 3 19.9992C3 20.5492 3.45 20.9992 4 20.9992H20C20.55 20.9992 21 20.5492 21 19.9992C21 19.4492 20.55 18.9992 20 18.9992H11.32L13.92 16.3981L20.7 9.61526C21.09 9.22509 21.09 8.59483 20.7 8.20467L15.79 3.29262C15.4 2.90246 14.77 2.90246 14.38 3.29262L7.60202 10.0734C7.60135 10.0741 7.60067 10.0748 7.6 10.0754C7.59932 10.0761 7.59865 10.0768 7.59797 10.0775L3.98 13.697C3.59 14.0871 3.59 14.7174 3.98 15.1075ZM8.31 12.1963L6.11 14.3972L9.6 17.8887L11.8 15.6878L8.31 12.1963ZM13.21 14.2772L18.58 8.90496L15.09 5.41351L9.72 10.7857L13.21 14.2772Z"
                    fill="#2A589F"
                />
              </svg>
            </span>
            &nbsp;&nbsp;
            <span
                @click="handleDeleteClick($event, item)"
            >
              <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13 3.99H19C19.55 3.99 20 4.44 20 4.99C20 5.54 19.55 5.99 19 5.99V20C19 20.55 18.55 21 18 21H6C5.45 21 5 20.55 5 20V5.99C4.45 5.99 4 5.54 4 4.99C4 4.44 4.45 3.99 5 3.99H11V3C11 2.45 11.45 2 12 2C12.55 2 13 2.45 13 3V3.99ZM7 5.99V19H17V5.99H7ZM9.91998 15.5C10.47 15.5 10.92 15.05 10.92 14.5V10.49C10.92 9.93999 10.47 9.48999 9.91998 9.48999C9.36998 9.48999 8.91998 9.93999 8.91998 10.49V14.5C8.91998 15.06 9.35998 15.5 9.91998 15.5ZM14.09 15.5C14.64 15.5 15.09 15.05 15.09 14.5V10.49C15.09 9.93999 14.64 9.48999 14.09 9.48999C13.54 9.48999 13.09 9.93999 13.09 10.49V14.5C13.09 15.06 13.54 15.5 14.09 15.5Z"
                    fill="#D83B01"
                />
              </svg>
            </span>
          </div>
          <div
              class="item item-value"
              style="-webkit-box-flex: 2;-ms-flex: 2 2 2rem;flex: 2 2 2rem;"
          >
            <span
                v-if="item.patient.patientEmail === userEmail"
            >
              <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.17 4.16C13.17 6.46 11.3 8.33 9.00002 8.33C6.70002 8.33 4.83002 6.47 4.83002 4.17C4.83002 1.87 6.70002 0 9.00002 0C11.3 0 13.17 1.86 13.17 4.16ZM11.17 4.17C11.17 2.97 10.19 2 9.00002 2C7.81002 2 6.83002 2.97 6.83002 4.17C6.83002 5.37 7.80002 6.34 9.00002 6.34C10.2 6.34 11.17 5.37 11.17 4.17ZM9.11 9.35001H10.35C14.57 9.35001 18 12.78 18 17C18 17.55 17.55 18 17 18C16.45 18 16 17.55 16 17C16 13.88 13.47 11.35 10.35 11.35H9.11H8.89H7.65C4.54 11.35 2 13.88 2 17C2 17.55 1.55 18 1 18C0.45 18 0 17.55 0 17C0 12.78 3.43 9.35001 7.65 9.35001H8.89H9.11Z"
                    fill="#000000"
                />
              </svg>
            </span>
            <span
                v-else-if="item.patient.isAccountSync === false"
                style="cursor: help;"
                v-tooltip="$t('alert.not_member_app')"
            >
              <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 10C0 4.48 4.48 0 10 0C15.53 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10ZM12.14 6.46001C12.53 6.07001 13.16 6.07001 13.55 6.46001C13.94 6.85001 13.94 7.48001 13.55 7.87001L11.42 10L13.57 12.13C13.96 12.52 13.96 13.15 13.57 13.54C13.37 13.73 13.12 13.83 12.86 13.83C12.6 13.83 12.35 13.74 12.15 13.54L10.02 11.41L7.88997 13.54C7.68997 13.73 7.44001 13.83 7.18001 13.83C6.92001 13.83 6.66999 13.74 6.46999 13.54C6.07999 13.15 6.07999 12.52 6.46999 12.13L8.59999 10L6.46999 7.87001C6.07999 7.48001 6.07999 6.85001 6.46999 6.46001C6.85999 6.07001 7.48996 6.07001 7.87996 6.46001L10.01 8.59001L12.14 6.46001Z"
                    fill="#D83B01"
                />
              </svg>
            </span>
            <span
                v-else
            >
              <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8706 1.22301C12.5022 -0.40767 15.1447 -0.40767 16.7763 1.22301C18.4079 2.85369 18.4079 5.49479 16.7763 7.12547L13.0727 10.827C12.2819 11.6173 11.2309 12.0475 10.1198 12.0475C9.00875 12.0475 7.95773 11.6173 7.16696 10.827C6.77658 10.4369 6.77658 9.80659 7.16696 9.41643C7.55734 9.02626 8.18796 9.02626 8.57834 9.41643C9.39914 10.2368 10.8305 10.2368 11.6513 9.41643L15.3549 5.71488C15.7653 5.30471 15.9956 4.75448 15.9956 4.17424C15.9956 3.594 15.7653 3.04377 15.3549 2.6336C14.5141 1.78324 13.1328 1.78324 12.2819 2.6336L9.95968 4.95457C9.5693 5.34473 8.93868 5.34473 8.54831 4.95457C8.15793 4.5644 8.15793 3.93414 8.54831 3.54398L10.8706 1.22301ZM5.71556 15.3689L8.03782 13.0479C8.4282 12.6578 9.05881 12.6578 9.44919 13.0479C9.83957 13.4381 9.83957 14.0684 9.44919 14.4585L7.12693 16.7795C6.33616 17.5698 5.28514 18 4.17406 18C3.06298 18 2.01195 17.5698 1.22119 16.7795C0.430416 15.9892 0 14.9387 0 13.8283C0 12.7178 0.430416 11.6674 1.22119 10.877L4.92479 7.17549C6.55638 5.54481 9.19895 5.54481 10.8305 7.17549C11.2209 7.56565 11.2209 8.19591 10.8305 8.58608C10.4402 8.97624 9.80954 8.97624 9.41916 8.58608C8.57834 7.73572 7.197 7.73572 6.34617 8.58608L2.64257 12.2876C2.23217 12.6978 2.00195 13.248 2.00195 13.8283C2.00195 14.4085 2.23217 14.9587 2.64257 15.3689C3.46337 16.1892 4.89476 16.1892 5.71556 15.3689Z" fill="#0d469e"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <ScheduleEditModal
        @getMySchedule="getMySchedule"
    />
  </div>
</template>

<script>
import _API from '../../../api';
import ScheduleEditModal from '../../modal/scheduleCalendar/scheduleEdit'
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {GENDER_TRANS} from "@/enum/lib"

export default {
  components: {
    ScheduleEditModal,
  },
  props: [
    'data',
  ],
  data() {
    return {
      checkedArr: [],
      beforeAppointment: -15, // 15분 전
      clickData: undefined,
      userEmail: localStorage.getItem('userEmail'),
    }
  },
  methods: {
    ...mapActions(['inspectSelectPatient', 'initPatientList', 'refreshScheduleForToday']),
    ...mapGetters(['getDeviceBrowser']),
    ...mapMutations(['initPatientList']),
    clickUser(seqPatient) {
      this.inspectSelectPatient(seqPatient);
      this.$router.push(`/patientList/details/home?id=${seqPatient}`);
    },
    isChecked(seqPatient) {
      for (let checkedValue of this.checkedArr) {
        if (seqPatient === checkedValue)
          return true;
      }
    },
    /**
     * 원격상담 화면을 연다.
     * @param selectedSchedule
     */
    startRmc(selectedSchedule, check) {
      if (check) {
        if (this.$store.getters.getVideoCallOpen) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.already_in_progress'
          });
          return
        }
        // isMobile  여부에 따라 페이지 이동 여부 분기 처리
        if (this.getDeviceBrowser().notNewWindow) {
          this.$router.push('/remote');
        }

        this.$store.dispatch('toggleRemoteModal', {open: true, selectedSchedule: selectedSchedule});
      } else {
        // TODO: 불가 팝업
      }
    },
    onEventClick(event, item) {
      event.stopPropagation();

      // TODO: 다른 브라우저 혹은 PC는 ?? 로그아웃 되겠지.? 다른 탭은??
      if (this.$store.getters.getVideoCallOpen === true && this.$store.getters?.getVideoCallSelectedSchedule?.seqSchedule === item.schedule.seqSchedule) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.already_in_progress'
        });
        return;
      }

      const minutes = this.moment.duration(item.schedule.scheduleExpectProgressTime).asMinutes();
      let classTxt = '';
      let status = '';
      let title = '';

      // 클래스 부여
      if (item.schedule.isAppointed) {
        // 의사가 예약한 스케쥴
        status = "doctor_appointment";
        classTxt = 'doctor_appointment';
      } else if (!item.schedule.isAppointed && item.schedule.seqMedicalRelation === 0) {
        // 의사가 설정한 예약 가능한 스케쥴
        status = "available";
        classTxt = 'available';
      } else if (!item.schedule.isAppointed && item.schedule.seqMedicalRelation !== 0) {
        // 환자가 예약한 스케쥴, 취소가 불가능함.
        status = "patient_appointment";
        classTxt = 'patient_appointment';
      }

      if (item.schedule.scheduleStatus === 2) {
        title = item.patient.patientInfo.patientInfoName + `(${this.$t('status.delete')})`;
        classTxt = "canceled_appointment";
        status = "canceled_appointment";
      } else if (item.schedule.scheduleStatus === 1) {
        title = item.patient.patientInfo.patientInfoName + `(${this.$t('status.completed')})`;
        classTxt = classTxt + " completed_appointment";
        status = "completed_appointment";
      } else {
        title = item.patient.patientInfo.patientInfoName;
      }

      this.$modal.show('schedule-edit-modal', {
        start: this.moment(item.schedule.scheduleExpectStartDatetime).format('YYYY-MM-DD HH:mm'),
        end: this.moment(this.moment(item.schedule.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).add(minutes, "m").format('YYYY-MM-DD HH:mm'),
        date: this.moment(this.moment(item.schedule.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).format('YYYY-MM-DD'),
        startTime: this.moment(this.moment(item.schedule.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).format('HH:mm'),
        expectProgressTime: item.schedule.scheduleExpectProgressTime,
        seqMedicalRelation: item.schedule.seqMedicalRelation,
        seqSchedule: item.schedule.seqSchedule,
        scheduleStatus: item.schedule.scheduleStatus,
        class: classTxt,
        status: status,
        title: title,
      });
    },
    handleDeleteClick(event, item) {
      event.stopPropagation();
      this.clickData = item.schedule;
      this.$modal.show('yes-or-no-modal', {questionType: 'delete', function: this.cancelSchedule})
    },
    cancelSchedule() {
      // TODO: 다른 브라우저 혹은 PC는 ?? 로그아웃 되겠지.? 다른 탭은??
      if (this.$store.getters.getVideoCallOpen === true && this.$store.getters?.getVideoCallSelectedSchedule?.seqSchedule === this.clickData?.seqSchedule) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.already_in_progress'
        });
        return;
      }

      // 대기 상태의 스케쥴인지 확인 scheduleStatus === 0 대기상태
      if (this.clickData.scheduleStatus !== 0) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.only_waiting_can_be_canceled'
        });
        return;
      }

      return _API.SCHEDULE.cancelNotStartedYetSchedule(this.clickData.seqSchedule)
          .then(({data}) => {
            if (data?.isSuccess) {
              this?.$modal?.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.delete_completed'
              });
            } else {
              this?.$modal?.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.unexpected_error'
              });
            }
            this.refreshScheduleForToday(true);
          })
          .catch(e => {
            console.log(`[cancelNotStartedYetSchedule] ${e}`);
          });
    },
    getMySchedule() {
      this.refreshScheduleForToday(true);
    },
  },
  computed: {
    scheduleStatus() {
      return (scheduleExpectStartDatetime) => {
        const appointment = this.moment(scheduleExpectStartDatetime).format('YYYY-MM-DD HH:mm');
        const diff = this.moment.duration(this.moment(this.currentTime).diff(appointment)).asMinutes();
        return (Math.floor(diff) >= this.beforeAppointment)
      };
    },
    computedGender() {
      return (patientInfoGender) => {
        return patientInfoGender ? this.$t(GENDER_TRANS[patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans)
      }
    }
  },
}
</script>
<style lang="scss">

.patient_all_list {
  overflow: auto;
  height: calc(var(--app-height) - 240px);

  .table-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 64px;
    width: 100%;
    .table-header {
      font-weight: bold;
      overflow: hidden;
    }
    .item-parent {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      &.row_select {
        background: var(--blue10);
        border: 1px solid var(--blue70);
        border-radius: 10px;
      }
      &.columns_2 {
        grid-column: 1/3;
      }
      &.row_2 {
        grid-row: 1/3;
      }
      .item {
        min-height: 64px;
        border-bottom: 1px solid var(--grey20);
        padding: 15px 0;
        overflow: hidden;
        &.item-title {
          flex: 1 1 1rem;
        }
        &.item-value {
          flex: 3 3 1rem;
        }
        &:nth-last-child(1) {
          border-right: none;
        }
      }
    }

    .table-header {
      background: var(--grey20);
      position: sticky;
      top: 0;

      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }

      .item-value:nth-child(3) {
        flex-grow: 7;
      }
    }

    .item-parent {
      margin: 0;
    }

    .table-body {
      background: #f7f7f7;

      &:hover {
        transition: background-color 0.5s;
        background-color: #f7fbff;
      }

      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }

      .item-value:nth-child(3) {
        flex-grow: 7;
      }
    }

    svg, img{
      cursor: pointer;
    }

    .table-header, .table-body {
      .item-value {
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-left: 10px;
        padding-right: 10px;

        span {
        }
      }
    }
  }
}
</style>